import {
	type WalletConnectConfirmActionProps,
	WalletConnectConfirmationActions,
	type WalletConnectSession
} from '@socios-blk/core';
import React, { useCallback } from 'react';

import { ApproveTransactionModal } from './components/ApproveTransactionModal';
import { SendTransactionModal } from './components/SendTransactionModal';
import { SessionConnectionModal } from './components/SessionConnectionModal';
import { SignMessageModal } from './components/SignMessageModal';
import { SignTypedDataModal } from './components/SignTypedDataModal';

export const useWalletConnectConfirmationMessage = (walletConnectSessions: Array<WalletConnectSession>) => {
	const getMessage = useCallback(
		({ action, origin, payload }: WalletConnectConfirmActionProps) => {
			switch (action) {
				case WalletConnectConfirmationActions.AUTH_DAPP:
					return <SessionConnectionModal payload={payload} />;
				case WalletConnectConfirmationActions.APPROVE: {
					return <ApproveTransactionModal origin={origin} payload={payload} />;
				}

				case WalletConnectConfirmationActions.SEND_TRANSACTION:
				case WalletConnectConfirmationActions.TRANSFER:
				case WalletConnectConfirmationActions.TRANSFER_FROM:
				case WalletConnectConfirmationActions.STAKE:
				case WalletConnectConfirmationActions.CLAIM:
				case WalletConnectConfirmationActions.UNSTAKE: {
					return <SendTransactionModal action={action} origin={origin} payload={payload} />;
				}

				// We show the message from the dApp as it is and allow user signing
				case WalletConnectConfirmationActions.SIGN_MESSAGE:
				case WalletConnectConfirmationActions.ETH_SIGN: {
					const { message, origin } = payload;

					return <SignMessageModal message={message} origin={origin} />;
				}

				// Handle eth_signTypedData_v4 and eth_sign with structured data
				case WalletConnectConfirmationActions.ETH_SIGN_TYPED_DATA_V4: {
					const { address, domain, message, primaryType, types } = payload;

					return (
						<SignTypedDataModal
							address={address}
							domain={domain}
							message={message}
							origin={origin}
							primaryType={primaryType}
							types={types}
						/>
					);
				}

				default:
					return <SendTransactionModal action={action} origin={origin} payload={payload} unknown />;
			}
		},
		[walletConnectSessions]
	);

	return {
		getMessage
	};
};
